import { CircularProgress, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import AvatarEditor from 'react-avatar-editor'
import { useEffect, useState } from 'react'
import { UserDTO } from '../../models/users'
import UserService from '../../services/UserService'
import { isCurrentUser, normalizeString } from '../../helpers/utils'
import CustomInput from '../TextInput'
import NoResults from '../../containers/NoResults'

interface Props {
    text: string
    handleClose: () => void
    handleSelectGraduate: (user: UserDTO) => void
}
const SearchGraduatesModal = ({ text, handleSelectGraduate, handleClose }: Props) => {
    const [graduates, setGraduates] = useState<UserDTO[]>()
    const [filteredGraduates, setFilteredGraduates] = useState<UserDTO[]>([])
    const [filter, setFilter] = useState<string>('')

    useEffect(() => {
        new UserService().getAllGraduates().then((response) => {
            if (response.status !== 200) return
            const users: UserDTO[] = response.data
            setGraduates(users.filter((user) => !isCurrentUser(user)))
        })
    }, [])

    useEffect(() => {
        if (!graduates || filter.trim() === '') return
        setFilteredGraduates(
            graduates.filter((user) =>
                normalizeString(`${user.firstName} ${user.lastName}`).includes(
                    normalizeString(filter),
                ),
            ),
        )
    }, [graduates, filter])

    return (
        <>
            {graduates ? (
                <div className="flex flex-col w-[60vw] md:w-[35vw] gap-1 md:gap-2">
                    <div className="flex items-center">
                        <label className="text-secondary font-semibold">{text}</label>
                        <IconButton
                            onClick={handleClose}
                            className="ml-auto p-0 text-primary"
                        >
                            <ClearIcon />
                        </IconButton>
                    </div>
                    <CustomInput
                        type="text"
                        name="filter"
                        value={filter}
                        className="mt-2"
                        label="Buscar por nombre"
                        onChange={(event) => setFilter(event.target.value)}
                    />
                    <div className="flex flex-col max-h-[48vh] md:max-h-[60vh] overflow-y-aut mt-2 md:mt-0 px-2 md:px-5">
                        {filter !== '' &&
                            (filteredGraduates.length > 0 ? (
                                filteredGraduates.map((user) => (
                                    <div
                                        key={user.id}
                                        className="flex flex-col mt-1 md:mt-2 gap-2 md:gap-4 bg-light rounded-[20px] p-2 shadow box-border w-full cursor-pointer"
                                        onClick={() => {
                                            handleSelectGraduate(user)
                                            handleClose()
                                        }}
                                    >
                                        <div className="flex gap-2 md:gap-4 items-center">
                                            <div>
                                                <AvatarEditor
                                                    image={
                                                        !!user.picture
                                                            ? user.picture
                                                            : '/adminPhoto.png'
                                                    }
                                                    height={40}
                                                    width={40}
                                                    border={0}
                                                    className="z-1 rounded-full pointer-events-none"
                                                />
                                            </div>
                                            <span className="text-sm md:text-base">
                                                {user.firstName + ' ' + user.lastName}
                                            </span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <NoResults />
                            ))}
                    </div>
                </div>
            ) : (
                <div className="flex w-full justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            )}
        </>
    )
}

export default SearchGraduatesModal
